import LegacyPage, { StartPage } from "../Pages/LegacyPage";
import UploadPage from "../Pages/UploadPage";
import ListCategoriesPage from "../Pages/ListCategoriesPage";
import CreateTemplateProductPage from "../Pages/CreateTemplateProductPage";
import ListTemplatesPage from "../Pages/ListTemplatesPage";
import ShoppingCartPage from "../Pages/ShoppingCart/ShoppingCartPage";
import EditProductPage from "../Pages/ShoppingCartEditProductPage";
import CheckoutDeliveryPage from "../Pages/CheckoutDelivery/CheckoutDeliveryPage";
const Routes = {
    startpage: {
        path: "/",
        component: StartPage,
        protected: false,
    },
    legacypage: {
        path: "/pages/:id",
        component: LegacyPage,
        protected: false,
    },
    uploadpage: {
        path: "/upload",
        component: UploadPage,
        protected: false,
    },
    products: {
        path: "/products",
        component: ListCategoriesPage,
        protected: false,
    },
    "templates.type.category": {
        path: "/products/:type/:category",
        component: ListTemplatesPage,
        protected: false,
    },
    "template.type.category": {
        path: "/products/:type",
        component: ListTemplatesPage,
        protected: false,
    },
    "products.cards.category": {
        path: "/products/:type/:category",
        component: ListTemplatesPage,
        protected: true,
    },
    "products.calendars.create": {
        path: "/products/calendars/:productUuid/:templateUuid",
        component: CreateTemplateProductPage,
        protected: false,
    },
    "products.categories.category.create": {
        path: '/products/:type/:category/:productUuid/:templateUuid',
        component: CreateTemplateProductPage,
        protected: true,
    },
    shoppingcart: {
        path: "/cart",
        component: ShoppingCartPage,
        protected: false,
    },
    "shoppingcart.view": {
        path: "/cart/view/:orderpartUuid",
        component: ShoppingCartPage,
        protected: false,
    },
    "shoppingcart.edit": {
        path: "/cart/edit/:uuid",
        component: EditProductPage,
        protected: false,
    },
    "shoppingcart.checkout": {
        path: "/cart/checkout",
        component: CheckoutDeliveryPage,
        protected: false,
        exact: false
    },
};
const useMobileRoutes = () => {
    return Routes;
};
export default useMobileRoutes;
